import { LocationType } from './types';

export const SIDE_HQ_COORDS = {
  lat: 37.77854,
  lng: -122.39698,
  type: LocationType.DEFAULT,
};

export const DEFAULT_ZOOM = 11;

export const DEFAULT_LOCALE_IDS = ['currentLocation', 'primaryOffice'];

// Maximum time, in ms, for current position to be acquired when loading map
export const GEOLOCATION_TIMEOUT = 3000;
